import "normalize.css";
import "web-ui/styles/fonts.scss";

import React from "react";
import ReactDOM from "react-dom";

// eslint-disable-next-line import/order
import App from "components/App";

import "styles/index.scss";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
